import { createEntityAdapter, EntityState } from '@ngrx/entity';

import {
  HttpTrialAccountRequestFilters,
  TrialAccountRequestFilterType,
  TrialAccountRequest,
} from '../models';

export const stateName = 'trial-accounts-requests';

export interface TrialAccountsRequestsState
  extends EntityState<TrialAccountRequest> {
  isLoading?: boolean;
  error?: string;
  filters?: HttpTrialAccountRequestFilters[];
}

export const sortByRequestedDate = (
  a: TrialAccountRequest,
  b: TrialAccountRequest,
) => new Date(b.requestedAt).getTime() - new Date(a.requestedAt).getTime();

export const trialAdapter = createEntityAdapter<TrialAccountRequest>({
  selectId: (i) => i.id,
  sortComparer: sortByRequestedDate,
});

export const trialInitialState = trialAdapter.getInitialState({
  isLoading: false,
});
